export enum PaginatedStoreIdsEnum {
  MANAGE_INSTITUTE_TESTS = "manageInstituteTests",
  MANAGE_ASSIGNMENTS = "manageAssignments",
  MANAGE_LIVE_CLASSES = "manageLiveClasses",
  MANAGE_LIVE_PRACTICE = "manageLivePractice",
  MANAGE_AFFILIATIONS = "manageAffiliations",
  OFFLINE_TEST_SUBJECT_WISE_REPORT = "offlineTestSubjectWiseReport",
  MANAGE_QR_CODES = "manageQrCodes",
  TUTORING_TUTOR_DASHBOARD = "tutoringTutorDashboard",
  TUTORING_STUDENT_DASHBOARD = "tutoringStudentDashboard",
  TUTORING_ADMIN_DEMO_SESSIONS = "tutoringAdminDemoSessions",
  TUTORING_ADMIN_PAID_SESSIONS = "tutoringAdminPaidSessions",
  MANAGE_SCHOOLS = "manageSchools",
  CREATE_PRELOADED_CONTENT = "createPreloadedContent",
  MANAGE_USERS = "manageUsers",
  TUTOR_SESSION_REPORTS = "tutorSessionReports",
  MANAGE_PRELOADED_CONTENT = "managePreloadedContent",
}

export enum FilterableStoreIdsEnum {
  MANAGE_TUTORING_DEMO_STUDENTS = "manageTutoringDemoStudents",
  MANAGE_TUTORING_PAID_STUDENTS = "manageTutoringPaidStudents",
  MANAGE_SCHOOLS = "manageSchools",
  MANAGE_BATCHES = "manageBatches",
  THE_SEARCH_USERS_BY_TEXT = "theSearchUsersByText",
  MANAGE_PRELOADED_CONTENT = "managePreloadedContent",
  TUTORING_STUDENT_STUDY_NOTES = "tutoringStudentStudyNotes",
  TUTOR_UNASSIGNED_DEMOS = "tutorUnassignedDemos",
  TUTORING_TUTOR_LESSON_PLANS = "tutoringTutorLessonPlans",
  TUTORING_MONTHLY_REPORT = "tutoringMonthlyReport",
  MANAGE_SCHOOL_USERS = "manageSchoolUsers",
  MANAGE_OMR_UPLOADS = "manageOrmUploads",
  MANAGE_PAST_YEAR_PAPERS = "managePastYearPapers",
}
